import type { ISVGIconProps } from "@ab.uitools/ui-library/components/SVGIcons/types";
import classNames from "classnames";

export const SEKSymbolIcon = ({
  size,
  type,
  className = "",
  onClick,
  refHandler,
  id,
  dataId,
}: ISVGIconProps) => {
  return (
    <svg
      className={classNames("svg-icon", {
        [`svg-icon__size-${size}`]: size,
        [`svg-icon__type-${type}`]: type,
        [className]: className,
      })}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      ref={refHandler}
      id={id}
      data-id={dataId ? `${dataId}-svg-icon` : ""}
    >
      <path
        d="M4.29962 3.64893C4.29962 3.28995 4.00861 2.99893 3.64962 2.99893C3.29064 2.99893 2.99962 3.28995 2.99962 3.64893V12.0229C2.9996 12.0257 2.9996 12.0284 2.99962 12.0311V16.3508C2.99962 16.7098 3.29064 17.0008 3.64962 17.0008C4.00861 17.0008 4.29962 16.7098 4.29962 16.3508V12.3271L4.90876 11.8087L9.4502 16.7881C9.69211 17.0534 10.1032 17.0723 10.3685 16.8304C10.6337 16.5885 10.6526 16.1773 10.4107 15.9121L5.89937 10.9657L8.94345 8.37509C9.21684 8.14243 9.24986 7.7322 9.0172 7.45881C8.78454 7.18543 8.37431 7.15241 8.10092 7.38507L4.29962 10.62V3.64893Z"
        fill="#888888"
      />
      <path
        d="M12.0307 7.23008C12.3897 7.23008 12.6807 7.52109 12.6807 7.88008V8.23433C12.9365 8.05187 13.2162 7.89643 13.5215 7.77682C14.394 7.4349 15.4091 7.41189 16.5551 7.79244C16.8958 7.90558 17.0802 8.27347 16.9671 8.61417C16.854 8.95486 16.4861 9.13933 16.1454 9.0262C15.2435 8.72672 14.5449 8.77202 13.9958 8.9872C13.4857 9.1871 13.0487 9.55578 12.6807 10.0472L12.6807 16.351C12.6807 16.71 12.3897 17.001 12.0307 17.001C11.6718 17.001 11.3807 16.71 11.3807 16.351V7.88008C11.3807 7.52109 11.6718 7.23008 12.0307 7.23008Z"
        fill="#888888"
      />
    </svg>
  );
};
